export const INFORMATION_CONSTANT = {
    // テーブル名
    TABLE: 'information',
  };
  